require("../faq-content/faq-content");

const adminRoot = document.querySelector("[data-admin-root]");

function initAdminFaqContent() {
  const store = window.NMFaqContent;
  if (!store || !adminRoot || window.NMAdminFaqContent) return;

  const contentHome = document.querySelector("[data-content-home]");
  const faqEditor = document.querySelector('[data-content-editor="faq"]');
  const faqList = document.querySelector("[data-faq-list-admin]");
  const faqCount = document.querySelector("[data-faq-count]");
  const faqStat = document.querySelector("[data-faq-stat-value]");
  const createBtn = document.querySelector("[data-faq-create]");
  const modal = document.querySelector("[data-faq-modal]");
  const form = document.querySelector("[data-faq-form]");
  const formTitle = document.querySelector("[data-faq-form-title]");

  let editingId = null;

  function hideOtherEditors() {
    if (contentHome) contentHome.hidden = true;
    document.querySelectorAll("[data-content-editor]").forEach((editor) => {
      const node = editor;
      node.hidden = node.getAttribute("data-content-editor") !== "faq";
    });
  }

  function clearErrors() {
    form?.querySelectorAll("[data-faq-field]").forEach((field) => {
      field.classList.remove("has-error");
      const error = field.querySelector("[data-faq-error]");
      if (error) error.hidden = true;
    });
  }

  function showError(name) {
    const field = form?.querySelector(`[data-faq-field="${name}"]`);
    if (!field) return;
    field.classList.add("has-error");
    const error = field.querySelector("[data-faq-error]");
    if (error) error.hidden = false;
  }

  function closeModal() {
    if (modal) modal.hidden = true;
    document.body.classList.remove("is-admin-modal-open");
    editingId = null;
    if (form) form.reset();
    clearErrors();
  }

  function openModal(itemId) {
    if (!form) return;
    const item = itemId
      ? store.getFaqItems().find((entry) => entry.id === itemId)
      : null;
    editingId = item ? item.id : null;

    form.elements.question.value = item?.question || "";
    form.elements.answer.value = item?.answer || "";
    form.elements.listTitle.value = item?.listTitle || "";
    form.elements.listType.value = item?.listType || "";
    form.elements.listText.value = (item?.listItems || []).join("\n");
    form.elements.showOnHome.checked = item ? item.showOnHome !== false : true;
    if (formTitle) {
      formTitle.textContent = item ? "Изменить вопрос" : "Новый вопрос";
    }
    clearErrors();
    if (modal) modal.hidden = false;
    document.body.classList.add("is-admin-modal-open");
  }

  function renderFaqAdmin() {
    const items = store.getFaqItems();
    if (faqCount) faqCount.textContent = `Вопросов: ${items.length}`;
    if (faqStat) faqStat.textContent = String(items.length);
    if (!faqList) return;

    if (!items.length) {
      faqList.innerHTML = `
        <div class="admin-panel__faq-empty">
          <p class="admin-panel__faq-empty-title">Пока нет вопросов</p>
          <p class="admin-panel__hint p3">Добавьте первый вопрос — он появится в блоке «Вопрос-ответ»</p>
        </div>
      `;
      return;
    }

    faqList.innerHTML = items.map((item, index) => {
      const number = String(index + 1).padStart(2, "0");
      const homeTag = item.showOnHome
        ? '<span class="admin-panel__faq-tag">На главной</span>'
        : '<span class="admin-panel__faq-tag admin-panel__faq-tag_muted">Только /faq</span>';

      return `
        <article class="admin-panel__faq-card">
          <div class="admin-panel__faq-index">${number}</div>
          <div class="admin-panel__faq-card-body">
            <div class="admin-panel__faq-card-head">
              <h4 class="admin-panel__faq-card-title">${store.escapeHtml(item.question)}</h4>
              ${homeTag}
            </div>
            <p class="admin-panel__faq-card-desc">${store.escapeHtml(item.answer)}</p>
          </div>
          <div class="admin-panel__faq-card-actions">
            <button class="admin-panel__action-btn" type="button" data-faq-edit="${store.escapeHtml(item.id)}">Изменить</button>
            <button class="admin-panel__action-btn admin-panel__action-btn_danger" type="button" data-faq-delete="${store.escapeHtml(item.id)}">Удалить</button>
          </div>
        </article>
      `;
    }).join("");
  }

  function showFaqEditor() {
    hideOtherEditors();
    if (faqEditor) faqEditor.hidden = false;
    closeModal();
    renderFaqAdmin();
  }

  function handleSubmit(event) {
    event.preventDefault();
    if (!form) return;
    clearErrors();

    const question = String(form.elements.question.value || "").trim();
    const answer = String(form.elements.answer.value || "").trim();

    if (!question) {
      showError("question");
      return;
    }
    if (!answer) {
      showError("answer");
      return;
    }

    store.upsertFaqItem({
      id: editingId || store.createId(),
      question,
      answer,
      listTitle: String(form.elements.listTitle.value || "").trim(),
      listType: String(form.elements.listType.value || "").trim(),
      listText: String(form.elements.listText.value || ""),
      showOnHome: Boolean(form.elements.showOnHome.checked),
    });

    store.hydratePublicFaq();
    closeModal();
    renderFaqAdmin();
  }

  document.querySelectorAll('[data-content-open="faq"]').forEach((button) => {
    button.addEventListener("click", showFaqEditor);
  });

  createBtn?.addEventListener("click", () => openModal(null));
  form?.addEventListener("submit", handleSubmit);

  document.querySelectorAll("[data-faq-modal-close]").forEach((el) => {
    el.addEventListener("click", closeModal);
  });

  faqList?.addEventListener("click", (event) => {
    const editBtn = event.target.closest("[data-faq-edit]");
    const deleteBtn = event.target.closest("[data-faq-delete]");
    if (editBtn) openModal(editBtn.getAttribute("data-faq-edit"));
    if (deleteBtn) {
      const id = deleteBtn.getAttribute("data-faq-delete");
      const item = store.getFaqItems().find((entry) => entry.id === id);
      // eslint-disable-next-line no-alert
      if (!item || !window.confirm(`Удалить вопрос «${item.question}»?`)) return;
      store.deleteFaqItem(id);
      store.hydratePublicFaq();
      if (editingId === id) closeModal();
      renderFaqAdmin();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    if (modal && !modal.hidden) closeModal();
  });

  window.NMAdminFaqContent = {
    showFaqEditor,
    closeModal,
    renderFaqAdmin,
  };

  renderFaqAdmin();
}

if (adminRoot) {
  initAdminFaqContent();
  window.setTimeout(initAdminFaqContent, 0);
}
